module.exports = __webpack_public_path__ + "img/arrow-form.2cfbeffc.svg";